import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Show } from "@clerk/react";
import { toast } from "sonner";
import axios from "axios";
import { Button } from "../components/ui/button";
import { API, useApi, errMsg } from "../lib/api";
import { GROUP_TYPES } from "../lib/constants";

function AcceptPanel({ token }) {
  const api = useApi();
  const nav = useNavigate();
  const [people, setPeople] = useState([]);
  const [link, setLink] = useState("");
  useEffect(() => { api.get("/people").then((r) => setPeople(r.data)); }, [api]);
  const accept = async () => {
    try { const r = await api.post(`/invites/${token}/accept`, { link_person_id: link || null }); toast.success("Invite accepted"); nav(`/app/profile/${r.data.person_id}`); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-4">
      {people.length > 0 && (
        <div className="space-y-2" data-testid="link-existing-options">
          <div className="text-sm text-slate-300">Already have a bsafe profile for this person? Link it so one profile sits in both groups.</div>
          <label className="flex items-center gap-2 text-sm"><input type="radio" checked={!link} onChange={() => setLink("")} data-testid="link-none-radio" /> Create a new profile</label>
          {people.map((p) => <label key={p.id} className="flex items-center gap-2 text-sm">
            <input type="radio" checked={link === p.id} onChange={() => setLink(p.id)} data-testid={`link-person-${p.id}`} /> Use existing: {p.first_name} {p.last_name}</label>)}
        </div>)}
      <Button data-testid="accept-invite-btn" className="w-full bg-red-600 hover:bg-red-500 text-white" onClick={accept}>Accept & set up profile</Button>
    </div>
  );
}

export default function InviteAccept() {
  const { token } = useParams();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { axios.get(`${API}/invites/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(errMsg(e))); }, [token]);
  const signIn = (path) => { localStorage.setItem("bsafe_invite", token); nav(path); };
  const t = GROUP_TYPES[info?.group?.type] || GROUP_TYPES.family;
  return (
    <div className="min-h-screen grain flex items-center justify-center p-4">
      <div className="panel p-8 max-w-md w-full relative z-10 fade-up" data-testid="invite-page" style={{ borderTop: `4px solid ${t.color}` }}>
        <div className="font-display font-black text-lg mb-6">bsafe<span className="text-red-500">.today</span></div>
        {error && <div data-testid="invite-error" className="text-red-300">{error}</div>}
        {info && (<>
          <div className="overline" style={{ color: t.color }}>{t.label} invite</div>
          <h1 className="text-2xl font-black mt-2">{info.group?.name} invited you</h1>
          <p className="text-slate-300 mt-3 text-sm">Set up the emergency profile for <b>{info.first_name}</b>. You own this profile: you choose which fields responders see. {info.group?.name} only sees how complete it is – never the medical details.</p>
          <div className="mt-6">
            <Show when="signed-in"><AcceptPanel token={token} /></Show>
            <Show when="signed-out"><div className="space-y-2">
              <Button data-testid="invite-signup-btn" className="w-full bg-red-600 hover:bg-red-500 text-white" onClick={() => signIn("/sign-up")}>Create account to continue</Button>
              <Button data-testid="invite-signin-btn" variant="outline" className="w-full" onClick={() => signIn("/sign-in")}>I already have an account</Button>
            </div></Show>
          </div>
        </>)}
      </div>
    </div>
  );
}
